// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@5.2.7/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".controls[data-v-ca93ed82]{justify-content:center;align-items:flex-end}.controls .left[data-v-ca93ed82]{position:absolute;left:2.5rem}@media screen and (max-width:1023px){.controls[data-v-ca93ed82]{flex-direction:column;gap:2rem;align-items:flex-start}.controls .dropdown-container[data-v-ca93ed82]{align-self:center}.controls .left[data-v-ca93ed82]{position:unset}}.limit-width[data-v-ca93ed82]{max-width:45rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
